import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "./ui/button";
import { useTranslation } from 'react-i18next';
import { PreLoginQuiz, QuizResultTeaser } from './PreLoginQuiz';
import OnboardingCarousel from './OnboardingCarousel';

const HomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showQuiz, setShowQuiz] = useState(false);
  const [quizResult, setQuizResult] = useState(null);

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleStartQuiz = () => {
    setShowQuiz(true);
    setQuizResult(null);
  };

  const handleQuizComplete = (result) => {
    setQuizResult(result);
  };

  const handleSaveResult = () => {
    // Quiz result is already stored in sessionStorage by PreLoginQuiz
    // Navigate to login - after login, the result will be persisted
    navigate('/login?fromQuiz=true');
  };

  const handleCloseQuiz = () => {
    setShowQuiz(false);
    setQuizResult(null);
  };

  // Show Quiz Result Teaser
  if (quizResult) {
    return (
      <div className="min-h-screen bg-black text-white">
        {/* Header */}
        <header className="bg-black relative z-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center py-3">
              <div className="flex items-center cursor-pointer" onClick={() => { setShowQuiz(false); setQuizResult(null); }}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_prospermind-charts/artifacts/bhqmeu3t_Logo%20ProsperMind.png" 
                  alt="ProsperMind"
                  className="h-16 w-auto"
                />
              </div>
              <Button
                onClick={handleLoginClick}
                className="bg-transparent border border-gray-600 text-gray-300 hover:bg-gray-800 px-4 py-2 rounded-lg"
              >
                {t('landing.alreadyHaveAccount')}
              </Button>
            </div>
          </div>
        </header>

        {/* Quiz Result Teaser */}
        <main className="max-w-4xl mx-auto px-4 py-12">
          <QuizResultTeaser 
            result={quizResult} 
            onSaveResult={handleSaveResult}
          />
        </main>
      </div>
    );
  }

  // Show Quiz
  if (showQuiz) {
    return (
      <div className="min-h-screen bg-black text-white">
        {/* Header */}
        <header className="bg-black relative z-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center py-3">
              <div className="flex items-center cursor-pointer" onClick={handleCloseQuiz}>
                <img 
                  src="https://customer-assets.emergentagent.com/job_prospermind-charts/artifacts/bhqmeu3t_Logo%20ProsperMind.png" 
                  alt="ProsperMind"
                  className="h-16 w-auto"
                />
              </div>
            </div>
          </div>
        </header>

        {/* Quiz */}
        <main className="max-w-4xl mx-auto px-4 py-12">
          <PreLoginQuiz 
            onComplete={handleQuizComplete}
            onClose={handleCloseQuiz}
          />
        </main>
      </div>
    );
  }

  // New Onboarding Carousel Landing Experience
  return (
    <OnboardingCarousel 
      onStartQuiz={handleStartQuiz}
      onLogin={handleLoginClick}
    />
  );
};

export default HomePage;
